module.exports = __webpack_public_path__ + "static/media/101.fc70ce81.webp";